import React, { useContext } from 'react';
import { FactContext } from '../context/FactContext';
import Loader from '../components/loader';
import Fact from '../components/fact';

const Contract = () => {
    const { connectWallet, currentAccount, getFact, isLoading, transactionHash } = useContext(FactContext);
    const status = {
        NO_WALLET: "no_wallet",
        WALLET_CONNECTED: "wallet_connected",
        TRANSACTION_LOADING: "transaction_loading",
        TRANSACTION_COMPLETE: "transaction_complete",
        ERROR: "error"
    }

    const buildUIForState = state => {
        if(state == status.NO_WALLET) {
            return (
                <button 
                    className="contract-button" 
                    onClick={connectWallet}>
                    {'Connect Wallet'}
                </button>
            );
        } else if(state == status.WALLET_CONNECTED) {
            return (
                <button 
                    className="contract-button" 
                    onClick={getFact}>
                    {'Get Fact'}
                </button>
            )
        } else if(state == status.TRANSACTION_LOADING) {
            return (
                <div>
                    <Loader></Loader>
                    <a href={`https://rinkeby.etherscan.io/tx/${transactionHash}`}
                       className="transaction-hash" target="_blank">
                        Transaction
                    </a>
                </div>
            )
        } else if(state == status.TRANSACTION_COMPLETE) {
            return (
                <Fact></Fact>
            )
        } else {
            return (
                <p>{'Something went wrong!'}</p>
            )
        }
    }

    const getState = () => {
        if(!currentAccount) {
            return status.NO_WALLET;
        } else if(currentAccount && !isLoading && !transactionHash) {
            return status.WALLET_CONNECTED;
        } else if(currentAccount && isLoading) {
            return status.TRANSACTION_LOADING;
        } else if(currentAccount && !isLoading && transactionHash) {
            return status.TRANSACTION_COMPLETE;
        } else {
            return status.ERROR;
        }
    }

    return (
        <div>
            {buildUIForState(getState())}
        </div>
    )
}

export default Contract;